import React, { Component } from 'react';

import { typeMap, typeMapFitness } from '../constants';
import './index.scss';

const colors = ['#6BA126','#76C7FF','#1AAFD1','#A4B351','#96ADB9','#61b56b','#4e6672'];
const dental_colors = ['#6BA126','#76C7FF','#A4B351','#96ADB9','#61b56b','#4e6672'];
const roundTheDecimal=function(value1,value2){
    const value = validateNaN(value1/value2);
    return Math.round(Math.round(value *100  * 100) / 100);
 }
 const validateNaN = function(value){
    if(isNaN(value)){
        return 0;
    }else{
        return value;
    }
 }

class Graphs extends Component{
    constructor(props){
        super(props);
        this.state ={
            activeOutcomeTab: 'BOOKED',
            graphData:[]
        }
    }
    componentDidMount(){
        const { conversation_outcomes } = this.props;
        this.processDataForGraph(conversation_outcomes.outcome_counts);
     }

    processDataForGraph=(outcome_counts)=>{
        const { BOOKED, CONVERSATIONS, CANCELLED, HANDLED, RESCHEDULED, UNRESPONSIVE, NONONLINE_CONVERSATIONS, MEMBERSHIP_PURCHASE, MEMBERSHIP_CANCEL, USER_RESPONDED } = outcome_counts;
        let formatted_outcome= [];
        const { domain, booking_software } = this.props.auth;
        const labelMap = (domain === 'FITNESS')?typeMapFitness:typeMap;
        formatted_outcome.push({ label: labelMap['BOOKED'], percentage: roundTheDecimal(BOOKED, CONVERSATIONS) + '%', count: BOOKED });
        formatted_outcome.push({ label: labelMap['CANCELLED'], percentage: roundTheDecimal(CANCELLED, CONVERSATIONS) + '%', count: CANCELLED })
        if (booking_software !== 'NEXHEALTH' && (domain && domain !== 'FITNESS')) {
            formatted_outcome.push({ label: labelMap['RESCHEDULED'], percentage: roundTheDecimal(RESCHEDULED, CONVERSATIONS) + '%', count: RESCHEDULED })
        }
        formatted_outcome.push({ label: labelMap['ENGAGED'] , percentage: roundTheDecimal(USER_RESPONDED,CONVERSATIONS)+'%', count: USER_RESPONDED})
        if(domain && domain === 'FITNESS'){
            formatted_outcome.push({ label: labelMap['MEMBERSHIP_PURCHASE'] , percentage: roundTheDecimal(MEMBERSHIP_PURCHASE,CONVERSATIONS)+'%', count: MEMBERSHIP_PURCHASE})
            formatted_outcome.push({ label: labelMap['MEMBERSHIP_CANCEL'] , percentage: roundTheDecimal(MEMBERSHIP_CANCEL,CONVERSATIONS)+'%', count: MEMBERSHIP_CANCEL})
        }
        console.log('formatted_outcome',formatted_outcome);
        this.setState({
            graphData:formatted_outcome,
            slice_index:Math.round(formatted_outcome.length/2)
        })
    }

    render(){
        const { graphData,slice_index } = this.state;
        const { domain } = this.props.auth;
        const color_coding = (domain === 'DENTAL')?dental_colors:colors;
        //const slice_index = (domain === 'DENTAL')?2:3;
        return(
            <div className="graph-container">
                <div className="piechart-holder">
                    <div className="row-one">
                    {graphData.slice(0,slice_index).map((data,index)=>{
                    return <div key={index} className="slice">
                        <div className="slice_data">
                            <div className="slice_data_label">
                                <div className="colored-dot" style={{background:color_coding[index]}} > </div>
                                <div>{data.label}</div>
                             </div>
                            <div className="slice_data_value">
                                <span className="slice_data_value_percentage">{data.percentage}</span><span className="slice_data_value_count">({data.count})</span>  
                            </div>
                        </div>
                        <div className="slice_progress">
                            <div className="slice_progress_container">
                                <div className="bar" style={{width: data.percentage, background:color_coding[index]}}></div>
                            </div>
                        </div>
                    </div>
                    })}
                    </div>
                    <div className="row-two">
                    {graphData.slice(slice_index,graphData.length).map((data,index)=>{
                    return <div key={index} className="slice">
                        <div className="slice_data">
                            <div className="slice_data_label">
                                <div className="colored-dot" style={{background:color_coding[index+slice_index]}} > </div>
                                <div>{data.label}</div>
                             </div>
                            <div className="slice_data_value">
                                <span className="slice_data_value_percentage">{data.percentage}</span><span className="slice_data_value_count">({data.count})</span>  
                            </div>
                        </div>
                        <div className="slice_progress">
                            <div className="slice_progress_container">
                                <div className="bar" style={{width: data.percentage, background:color_coding[index+slice_index]}}></div>
                            </div>
                        </div>
                    </div>
                    })}
                    </div>
                </div>
            </div>
        )
    }

}

export default Graphs;